import { render, staticRenderFns } from "./noticeTips.vue?vue&type=template&id=80b1fca0&scoped=true&"
import script from "./noticeTips.vue?vue&type=script&lang=ts&"
export * from "./noticeTips.vue?vue&type=script&lang=ts&"
import style0 from "./noticeTips.vue?vue&type=style&index=0&id=80b1fca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b1fca0",
  null
  
)

export default component.exports